var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectedOption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1132 3.32254C13.5448 2.89249 14.2446 2.89249 14.6763 3.32254C15.1079 3.75259 15.1079 4.44984 14.6763 4.87989L6.52632 13L1.32372 7.81646C0.892092 7.38641 0.892092 6.68916 1.32372 6.25911C1.75536 5.82906 2.45517 5.82906 2.8868 6.25911L6.52632 9.88529L13.1132 3.32254Z",
    fill: "currentColor"
  })));
}

export default SvgSelectedOption;